import { dataSourceDropdownBinder } from "./dataSourceDropdownBinder";
import { DatasourceService } from "../../services/DatasourceService";
import { dataSourceItem } from "../../redux/models/reduxModels";

export class DataSourceDropdownInitializer {
    constructor(private dataSourceService: DatasourceService, private datasourceItem: dataSourceItem, private displayName: string, private multiSelect: boolean) { }

    initialize = async (propSetter: any) => {
        const dropdownBinder = new dataSourceDropdownBinder(this.dataSourceService, this.datasourceItem, this.displayName);
        const property = dropdownBinder.getDataSourcePropertyToBindTo();
        if (property) {
            const datasourceData = await dropdownBinder.getDatasourceEntries();
            const dropdownOptions = dropdownBinder.bindDataSourceToDropdown(datasourceData, property);
            propSetter(this.multiSelect ? dropdownOptions : [{ key: null, text: "" }, ...dropdownOptions]);   
        }
    }
}